// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sa-img-carousel-popup-container {
  background: rgba(32, 33, 36, 0.4);
  width: 100%;
  height: 100%;
  position: fixed;
  margin-left: -8px;
  font-family: inter;
  z-index: 999999;
  top: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}
#sa-img-carousel-popup-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
#sa-img-carousel-popup-container::-webkit-scrollbar-track {
  background: transparent;
}
#sa-img-carousel-popup-container::-webkit-scrollbar-thumb {
  background-color: rgba(128, 134, 139, 0.2);
  border-radius: 4px;
  border: 1px solid transparent;
  background-clip: padding-box;
  transition: background-color 0.15s ease;
}
#sa-img-carousel-popup-container::-webkit-scrollbar-thumb:hover {
  background-color: rgba(128, 134, 139, 0.4);
}
#sa-img-carousel-popup-container::-webkit-scrollbar-thumb:active {
  background-color: rgba(128, 134, 139, 0.5);
}
#sa-img-carousel-popup-container::-webkit-scrollbar-corner {
  background: transparent;
}
#sa-img-carousel-popup-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(128, 134, 139, 0.2) transparent;
}
#sa-img-carousel-popup-container .sa-image-preview {
  width: 100%;
  height: 100vh;
  max-width: 100%;
  background-color: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-carousel-btn {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 15;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  background-color: rgba(60, 64, 67, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: background-color 0.2s ease, transform 0.2s ease;
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto !important;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-carousel-btn:hover {
  background-color: rgba(95, 99, 104, 0.9);
  transform: translateY(-50%) scale(1.05);
}
#sa-img-carousel-popup-container .sa-image-preview .sa-carousel-btn.sa-carousel-btn-left {
  left: 12px;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-carousel-btn.sa-carousel-btn-right {
  right: 12px;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-carousel-btn svg {
  width: 8px;
  height: 13px;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-carousel-btn svg path {
  stroke: #FFFFFF;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: transparent;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  padding: 8px 24px;
  height: 64px;
  display: flex;
  align-items: center;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header.sa-header-scrolled {
  background-color: #0C111D !important;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header .sa-header-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header .sa-header-content .sa-header-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header .sa-header-content .sa-header-left .sa-back-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header .sa-header-content .sa-header-left .sa-back-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header .sa-header-content .sa-header-left .sa-back-btn svg {
  width: 24px;
  height: 24px;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header .sa-header-content .sa-header-left .sa-file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header .sa-header-content .sa-header-left .sa-file-icon svg {
  width: 22px;
  height: 22px;
  display: block;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header .sa-header-content .sa-header-left .sa-filename {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
  flex: 1;
  min-width: 0;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-header .sa-header-content .sa-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 20px 24px;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin-top: 64px;
  margin-bottom: 80px;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body.sa-single-image {
  margin-top: 100px;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body.sa-single-image .sa-preview-img {
  margin-top: 50%;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body::-webkit-scrollbar-track {
  background: transparent;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body::-webkit-scrollbar-thumb {
  background-color: rgba(128, 134, 139, 0.2);
  border-radius: 4px;
  border: 1px solid transparent;
  background-clip: padding-box;
  transition: background-color 0.15s ease;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body::-webkit-scrollbar-thumb:hover {
  background-color: rgba(128, 134, 139, 0.4);
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body::-webkit-scrollbar-thumb:active {
  background-color: rgba(128, 134, 139, 0.5);
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body::-webkit-scrollbar-corner {
  background: transparent;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body {
  scrollbar-width: thin;
  scrollbar-color: rgba(128, 134, 139, 0.2) transparent;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body .sa-preview-image-container {
  max-width: 75%;
  width: auto;
  max-height: none;
  overflow: visible;
  position: relative;
  transition: transform 0.3s ease;
  transform-origin: top center;
  margin: 20px auto;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body .sa-preview-image-container .sa-image-wrapper {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  overflow-x: hidden;
  overflow-y: visible;
  box-sizing: border-box;
  pointer-events: auto;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body .sa-preview-image-container .sa-image-wrapper .sa-image-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-body .sa-preview-image-container .sa-image-wrapper .sa-image-content .sa-preview-img {
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  user-select: none;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px 20px 24px 20px;
  background: linear-gradient(to top, rgba(32, 33, 36, 0.95) 0%, rgba(32, 33, 36, 0.85) 60%, rgba(32, 33, 36, 0.7) 80%, transparent 100%);
  pointer-events: none;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-zoom-controls {
  display: flex;
  align-items: center;
  background-color: rgba(60, 64, 67, 0.9);
  border-radius: 24px;
  padding: 6px 12px;
  gap: 8px;
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-zoom-controls .sa-zoom-controls-inner {
  display: flex;
  align-items: center;
  gap: 12px;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-zoom-controls .sa-zoom-controls-inner .sa-zoom-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  pointer-events: auto;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-zoom-controls .sa-zoom-controls-inner .sa-zoom-btn:hover {
  background-color: rgba(95, 99, 104, 0.9);
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-zoom-controls .sa-zoom-controls-inner .sa-zoom-btn svg {
  width: 20px;
  height: 20px;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-zoom-controls .sa-zoom-controls-inner .sa-zoom-btn svg path {
  stroke: #FFFFFF;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-zoom-controls .sa-zoom-controls-inner .sa-zoom-percentage {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  min-width: 50px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-zoom-controls .sa-zoom-controls-inner .sa-zoom-percentage:hover {
  background-color: rgba(95, 99, 104, 0.5);
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-preview-footer {
  display: flex;
  gap: 12px;
  padding: 12px;
  background-color: rgba(60, 64, 67, 0.9);
  border-radius: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  pointer-events: auto;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-preview-footer .sa-preview-thumbnail {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s ease, transform 0.2s ease;
  flex-shrink: 0;
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-preview-footer .sa-preview-thumbnail:hover {
  transform: scale(1.1);
  border-color: rgba(255, 255, 255, 0.5);
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-preview-footer .sa-preview-thumbnail.sa-thumbnail-active {
  border-color: #4285F4;
  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.3);
}
#sa-img-carousel-popup-container .sa-image-preview .sa-preview-bottom-controls .sa-preview-footer .sa-preview-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/plugins/answers/templates/imagePreviewTemplate/imagePreviewTemplate.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,MAAA;EACA,kBAAA;EACA,kBAAA;AACJ;AAEI;EACI,UAAA;EACA,WAAA;AAAR;AAGI;EACI,uBAAA;AADR;AAII;EACI,0CAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,uCAAA;AAFR;AAIQ;EACI,0CAAA;AAFZ;AAKQ;EACI,0CAAA;AAHZ;AAOI;EACI,uBAAA;AALR;AAlCA;EA2CI,qBAAA;EACA,qDAAA;AANJ;AAQI;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,wCAAA;EACA,0BAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AANR;AASQ;EACI,eAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,wCAAA;EACA,2DAAA;EACA,qBAAA;EACA,8BAAA;EACA,+BAAA;AAPZ;AASY;EACI,wCAAA;EACA,uCAAA;AAPhB;AAUY;EACI,UAAA;AARhB;AAWY;EACI,WAAA;AAThB;AAYY;EACI,UAAA;EACA,YAAA;AAVhB;AAWgB;EACI,eAAA;AATpB;AAeQ;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,6BAAA;EACA,4DAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAbZ;AAeY;EACI,oCAAA;AAbhB;AAgBY;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAdhB;AAgBgB;EACI,aAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;AAdpB;AAgBoB;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sCAAA;AAdxB;AAgBwB;EACI,0CAAA;AAd5B;AAiBwB;EACI,WAAA;EACA,YAAA;AAf5B;AAmBoB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAjBxB;AAmBwB;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAjB5B;AAqBoB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,OAAA;EACA,YAAA;AAnBxB;AAuBgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AArBpB;AA2BQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAzBZ;AA4BY;EACI,iBAAA;AA1BhB;AA4BgB;EACI,eAAA;AA1BpB;AA+BY;EACI,UAAA;EACA,WAAA;AA7BhB;AAgCY;EACI,uBAAA;AA9BhB;AAiCY;EACI,0CAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,uCAAA;AA/BhB;AAiCgB;EACI,0CAAA;AA/BpB;AAkCgB;EACI,0CAAA;AAhCpB;AAoCY;EACI,uBAAA;AAlChB;AAjBQ;EAuDI,qBAAA;EACA,qDAAA;AAnCZ;AAsCY;EACI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,4BAAA;EACA,iBAAA;AApChB;AAsCgB;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;AApCpB;AAsCoB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApCxB;AAsCwB;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AApC5B;AA4CQ;EACI,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,uIAAA;EACA,oBAAA;AA1CZ;AA4CY;EACI,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,wCAAA;AA1ChB;AA4CgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AA1CpB;AA4CoB;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sCAAA;EACA,oBAAA;AA1CxB;AA4CwB;EACI,wCAAA;AA1C5B;AA6CwB;EACI,WAAA;EACA,YAAA;AA3C5B;AA4C4B;EACI,eAAA;AA1ChC;AA+CoB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sCAAA;AA7CxB;AA+CwB;EACI,wCAAA;AA7C5B;AAmDY;EACI,aAAA;EACA,SAAA;EACA,aAAA;EACA,uCAAA;EACA,mBAAA;EACA,yCAAA;EACA,oBAAA;AAjDhB;AAmDgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,uDAAA;EACA,cAAA;AAjDpB;AAmDoB;EACI,qBAAA;EACA,sCAAA;AAjDxB;AAoDoB;EACI,qBAAA;EACA,6CAAA;AAlDxB;AAqDoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAnDxB","sourcesContent":["#sa-img-carousel-popup-container {\n    background: rgba(32, 33, 36, 0.4);\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    margin-left: -8px;\n    font-family: inter;\n    z-index: 999999;\n    top: 0;\n    overflow-x: hidden;\n    overflow-y: hidden;\n\n    // Google Drive style scrollbar - thinner and more subtle\n    &::-webkit-scrollbar {\n        width: 8px;\n        height: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(128, 134, 139, 0.2);\n        border-radius: 4px;\n        border: 1px solid transparent;\n        background-clip: padding-box;\n        transition: background-color 0.15s ease;\n\n        &:hover {\n            background-color: rgba(128, 134, 139, 0.4);\n        }\n\n        &:active {\n            background-color: rgba(128, 134, 139, 0.5);\n        }\n    }\n\n    &::-webkit-scrollbar-corner {\n        background: transparent;\n    }\n\n    // Firefox scrollbar\n    scrollbar-width: thin;\n    scrollbar-color: rgba(128, 134, 139, 0.2) transparent;\n\n    .sa-image-preview {\n        width: 100%;\n        height: 100vh;\n        max-width: 100%;\n        background-color: rgba(15, 23, 42, 0.55);\n        backdrop-filter: blur(6px);\n        -webkit-backdrop-filter: blur(6px);\n        position: relative;\n        overflow: hidden;\n        display: flex;\n        flex-direction: column;\n\n        // Carousel buttons - fixed position, always visible\n        .sa-carousel-btn {\n            position: fixed;\n            top: 50%;\n            transform: translateY(-50%);\n            z-index: 15;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 37px;\n            height: 37px;\n            border-radius: 50%;\n            background-color: rgba(60, 64, 67, 0.9);\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n            transition: background-color 0.2s ease, transform 0.2s ease;\n            opacity: 1 !important;\n            visibility: visible !important;\n            pointer-events: auto !important;\n\n            &:hover {\n                background-color: rgba(95, 99, 104, 0.9);\n                transform: translateY(-50%) scale(1.05);\n            }\n\n            &.sa-carousel-btn-left {\n                left: 12px;\n            }\n\n            &.sa-carousel-btn-right {\n                right: 12px;\n            }\n\n            svg {\n                width: 8px;\n                height: 13px;\n                path {\n                    stroke: #FFFFFF;\n                }\n            }\n        }\n\n        // Header - transparent initially, becomes black on scroll\n        .sa-preview-header {\n            position: fixed;\n            top: 0;\n            left: 0;\n            right: 0;\n            z-index: 100;\n            background-color: transparent;\n            transition: background-color 0.3s ease, box-shadow 0.3s ease;\n            padding: 8px 24px;\n            height: 64px;\n            display: flex;\n            align-items: center;\n\n            &.sa-header-scrolled {\n                background-color: #0C111D !important;\n            }\n\n            .sa-header-content {\n                width: 100%;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n\n                .sa-header-left {\n                    display: flex;\n                    align-items: center;\n                    flex: 1;\n                    min-width: 0;\n\n                    .sa-back-btn {\n                        cursor: pointer;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        width: 40px;\n                        height: 40px;\n                        border-radius: 50%;\n                        transition: background-color 0.2s ease;\n\n                        &:hover {\n                            background-color: rgba(255, 255, 255, 0.1);\n                        }\n\n                        svg {\n                            width: 24px;\n                            height: 24px;\n                        }\n                    }\n\n                    .sa-file-icon {\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        width: 40px;\n                        height: 40px;\n                        flex-shrink: 0;\n\n                        svg {\n                            width: 22px;\n                            height: 22px;\n                            display: block;\n                        }\n                    }\n\n                    .sa-filename {\n                        color: #FFFFFF;\n                        font-size: 18px;\n                        font-weight: 500;\n                        white-space: nowrap;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        text-transform: capitalize;\n                        flex: 1;\n                        min-width: 0;\n                    }\n                }\n\n                .sa-header-right {\n                    display: flex;\n                    align-items: center;\n                    gap: 16px;\n                }\n            }\n        }\n\n        // Preview body - scrollable content area\n        .sa-preview-body {\n            position: relative;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex: 1;\n            padding: 20px 24px;\n            overflow-x: hidden;\n            overflow-y: auto;\n            width: 100%;\n            max-width: 100%;\n            box-sizing: border-box;\n            margin-top: 64px;\n            margin-bottom: 80px;\n\n            // Single image (no carousel) - different margin\n            &.sa-single-image {\n                margin-top: 100px;\n\n                .sa-preview-img {\n                    margin-top: 50%;\n                }\n            }\n\n            // Google Drive style scrollbar for preview body\n            &::-webkit-scrollbar {\n                width: 8px;\n                height: 8px;\n            }\n\n            &::-webkit-scrollbar-track {\n                background: transparent;\n            }\n\n            &::-webkit-scrollbar-thumb {\n                background-color: rgba(128, 134, 139, 0.2);\n                border-radius: 4px;\n                border: 1px solid transparent;\n                background-clip: padding-box;\n                transition: background-color 0.15s ease;\n\n                &:hover {\n                    background-color: rgba(128, 134, 139, 0.4);\n                }\n\n                &:active {\n                    background-color: rgba(128, 134, 139, 0.5);\n                }\n            }\n\n            &::-webkit-scrollbar-corner {\n                background: transparent;\n            }\n\n            // Firefox scrollbar\n            scrollbar-width: thin;\n            scrollbar-color: rgba(128, 134, 139, 0.2) transparent;\n\n\n            .sa-preview-image-container {\n                max-width: 75%;\n                width: auto;\n                max-height: none;\n                overflow: visible;\n                position: relative;\n                transition: transform 0.3s ease;\n                transform-origin: top center;\n                margin: 20px auto;\n\n                .sa-image-wrapper {\n                    width: 100%;\n                    max-width: 100%;\n                    height: auto;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    background-color: #FFFFFF;\n                    border-radius: 8px;\n                    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n                    overflow-x: hidden;\n                    overflow-y: visible;\n                    box-sizing: border-box;\n                    pointer-events: auto;\n\n                    .sa-image-content {\n                        width: 100%;\n                        height: 100%;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n\n                        .sa-preview-img {\n                            max-width: 100%;\n                            width: auto;\n                            height: auto;\n                            object-fit: contain;\n                            display: block;\n                            user-select: none;\n                        }\n                    }\n                }\n            }\n        }\n\n        // Bottom controls - fixed at bottom\n        .sa-preview-bottom-controls {\n            position: fixed;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            z-index: 50;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 16px;\n            padding: 16px 20px 24px 20px;\n            background: linear-gradient(to top, rgba(32, 33, 36, 0.95) 0%, rgba(32, 33, 36, 0.85) 60%, rgba(32, 33, 36, 0.7) 80%, transparent 100%);\n            pointer-events: none;\n\n            .sa-zoom-controls {\n                display: flex;\n                align-items: center;\n                background-color: rgba(60, 64, 67, 0.9);\n                border-radius: 24px;\n                padding: 6px 12px;\n                gap: 8px;\n                opacity: 1;\n                visibility: visible;\n                pointer-events: auto;\n                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n\n                .sa-zoom-controls-inner {\n                    display: flex;\n                    align-items: center;\n                    gap: 12px;\n\n                    .sa-zoom-btn {\n                        cursor: pointer;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        width: 36px;\n                        height: 36px;\n                        border-radius: 50%;\n                        transition: background-color 0.2s ease;\n                        pointer-events: auto;\n\n                        &:hover {\n                            background-color: rgba(95, 99, 104, 0.9);\n                        }\n\n                        svg {\n                            width: 20px;\n                            height: 20px;\n                            path {\n                                stroke: #FFFFFF;\n                            }\n                        }\n                    }\n\n                    .sa-zoom-percentage {\n                        color: #FFFFFF;\n                        font-size: 14px;\n                        font-weight: 500;\n                        min-width: 50px;\n                        text-align: center;\n                        user-select: none;\n                        cursor: pointer;\n                        padding: 4px 8px;\n                        border-radius: 4px;\n                        transition: background-color 0.2s ease;\n\n                        &:hover {\n                            background-color: rgba(95, 99, 104, 0.5);\n                        }\n                    }\n                }\n            }\n\n            .sa-preview-footer {\n                display: flex;\n                gap: 12px;\n                padding: 12px;\n                background-color: rgba(60, 64, 67, 0.9);\n                border-radius: 24px;\n                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n                pointer-events: auto;\n\n                .sa-preview-thumbnail {\n                    width: 60px;\n                    height: 60px;\n                    border-radius: 8px;\n                    overflow: hidden;\n                    cursor: pointer;\n                    border: 2px solid transparent;\n                    transition: border-color 0.2s ease, transform 0.2s ease;\n                    flex-shrink: 0;\n\n                    &:hover {\n                        transform: scale(1.1);\n                        border-color: rgba(255, 255, 255, 0.5);\n                    }\n\n                    &.sa-thumbnail-active {\n                        border-color: #4285F4;\n                        box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.3);\n                    }\n\n                    img {\n                        width: 100%;\n                        height: 100%;\n                        object-fit: cover;\n                    }\n                }\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
